module.exports = __webpack_public_path__ + "media/images/favicons/favicon-friday-16x16-20d3c181b9880bee12fc9264c394fb1d.png";